import React from 'react'
import classnames from 'classnames'

import { Box, CustomizableDashboard } from '@domain-group/suit-theme'

import NotificationBannerLocation from '@components/NotificationBannerLocation'

import useCurrentUser, { CurrentUserPayload } from '@hooks/useCurrentUser'

import styles from './styles.module.scss'

const findLocationKey = (currentUserPayload: CurrentUserPayload) => {
  const { isBrandUser, isProviderUser } = currentUserPayload

  if (isBrandUser) return 'brand.helpdesk.dashboard.banner'
  if (isProviderUser) return 'provider.helpdesk.dashboard.banner'

  return 'admin.helpdesk.dashboard.banner'
}

interface ContentProps {
  draggablePlaceholder?: React.ReactNode,
  id?: string,
  isDraggingOver?: boolean,
  modules?: { key: string, moduleId: string }[],
}

const Content = React.forwardRef((props: ContentProps, ref) => {
  const {
    draggablePlaceholder, id, isDraggingOver, modules,
  } = props

  const currentUserPayload = useCurrentUser()

  return (
    <Box
      className={classnames(styles.root, isDraggingOver ? styles.draggingOver : null)}
      flexDirection="column"
      marginRight={[0, 0, 'large']}
      width={['100%', '100%', 'calc(100% - 375px)']}
    >
      <NotificationBannerLocation locationKey={findLocationKey(currentUserPayload)} />

      {/*
       // @ts-expect-error TS2322 */}
      <div ref={ref} style={{ flexGrow: 1, minHeight: '100vh' }}>
        {/*
         // @ts-expect-error TS2322 */}
        {modules && <CustomizableDashboard.ModuleRenderer modules={modules} parentId={id} />}
        {draggablePlaceholder}
      </div>
    </Box>
  )
})

export default Content
